// extracted by mini-css-extract-plugin
export var blockWithPayments = "Form-module--blockWithPayments--Out8F";
export var btn = "Form-module--btn--ahwe-";
export var containerTitleTooltip = "Form-module--containerTitleTooltip--vzyUx";
export var form = "Form-module--form--FRS8J";
export var formShadow = "Form-module--formShadow--nfEwZ";
export var hideSavingsVal = "Form-module--hideSavingsVal---FZzy";
export var info = "Form-module--info---gbKJ";
export var infoElem = "Form-module--infoElem--rSd-m";
export var infoElemTitle = "Form-module--infoElemTitle--0BiVX";
export var showSavingsVal = "Form-module--showSavingsVal--rrIpI";
export var value = "Form-module--value--grM8l";